exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modify-supplement-create[data-v-6ac75588] {\r\n  padding: 6px;\n}\n.title[data-v-6ac75588] {\r\n  font-weight: bold;\r\n  color: #303133;\n}\n.form-section[data-v-6ac75588] {\r\n  margin-bottom: 12px;\r\n  padding-bottom: 8px;\r\n  border-bottom: 1px dashed #ebeef5;\n}\n.section-title[data-v-6ac75588] {\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  color: #409EFF;\r\n  margin-bottom: 8px;\r\n  padding-left: 8px;\r\n  border-left: 3px solid #409EFF;\r\n  line-height: 1;\n}\n.form-footer[data-v-6ac75588] {\r\n  text-align: center;\r\n  padding: 12px 0 6px;\n}\r\n", ""]);

// exports
